import React, { FunctionComponent } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Typography } from '@material-ui/core';
import specificationsAccordionContentStyles from './specificationsAccordionContentStyles';
import { IFeatureItem } from '../../../../../../gqlCommon/model/IVariants';
import { useIntl } from 'react-intl';
import SpecificationDisclaimer from '../../../../../../gqlCommon/components/presentation/specificationDisclaimer/SpecificationDisclaimer';

export interface ISpecificationsAccordionContentProps {
  specification: IFeatureItem;
  hasTranslation?: boolean;
}

const SpecificationsAccordionContent: FunctionComponent<ISpecificationsAccordionContentProps> = ({
  specification,
  hasTranslation,
}) => {
  const intl = useIntl();
  const styles = specificationsAccordionContentStyles();
  const key = specification.name;
  const isNested = key && key[0] === '+';

  return (
    <TableRow key={key} className={styles.tableRow} data-test={`specification:detail:${key}`}>
      <TableCell className={styles.tableCell} data-test="specification:category">
        <Typography
          variant="caption"
          component="p"
          className={isNested ? styles.nestedCaption : null}
          dangerouslySetInnerHTML={
            hasTranslation
              ? {
                  __html: intl.formatMessage({
                    id: `trans__configurator__customise_page_full_specs_modal__${key}_label`,
                  }),
                }
              : null
          }
        >
          {hasTranslation ? null : (
            <>
              {isNested ? key.substring(1) : key}
              {specification?.disclaimer && <SpecificationDisclaimer disclaimer={specification.disclaimer} />}
            </>
          )}
        </Typography>
      </TableCell>
      <TableCell className={styles.tableCell} data-test="specification.value">
        <Typography variant="caption" component="p">
          {specification.value}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default SpecificationsAccordionContent;
